/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 57,
  image: "default-changelog-v2.png",
  title: "Improved Onboarding Flow, Dedicated IP, Google login, Design System Expansion & Platform Updates",
  shortDescription: "This update introduces a revamped onboarding UI, compute dashboard enhancements, global theme switching, dedicated IP support, Google/Gmail login, and expanded design system components for improved user interaction",
  description: "This update introduces a revamped onboarding UI, compute dashboard enhancements, global theme switching, dedicated IP support, Google/Gmail login, and expanded design system components for improved user interaction",
  date: "April 12th, 2024",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Compute", "Onboarding", "Google login", "Referral", "Multi-service", "CopperX", "billing", "payment", "Design system", "Enhancements", "fixes"]
};
export const content = `
Revamped Onboarding UI
----------------------

We're excited to announce the latest update to the Spheron platform, aimed at enhancing your onboarding experience and providing a more personalised and intuitive interface. Below are the details of the changes:

- **Signup Flow:**

  - We have overhauled the signup flow for new users, making it more intuitive and user-friendly.
  - When signing up, whether via web2 or web3, you'll now be presented with a screen to enter details about your primary usage of our platform, team size, your role (Developer, Designer, Devops Engineer, Product Manager, etc.), and the type of project you'll be building using the Spheron platform. This information will enable us to tailor your experience more effectively.

- **Compute Dashboard UI Update:**

  - Our compute dashboard now features video tutorials, guides, and other resources for quick access, making it easier than ever to get started and utilize Spheron's capabilities effectively.
  - We have added a new section where you can copy your referral URL to share with your developer friends, colleagues, and contacts, making it rewarding to bring others into the Spheron community.

- **Global Theme Switcher:**

  - You can now switch themes directly from the footer on the login/signup page. Your preferred theme will be saved and applied each time you log in to the platform.

## Dedicated IP

- Previously, Spheron only supported shared IPs, which limited access to random ports within the 30000-32676 range.
- Now, you have the option to select a dedicated IP, granting you access to the full range of ports, including 80 and 443. This is perfect for applications that require direct control over network traffic and specific port access.

This enhancement offers greater flexibility and control, allowing you to tailor your network settings precisely to your application's requirements.

## Sign in with Google:

- Following valuable feedback from our user community, we're introducing a seamless login option that lets you access Spheron using your Google/Gmail credentials.
- This addition aims to simplify your login experience, offering you more flexibility and convenience when accessing your Spheron account.

## Design System Components Expansion

We have expanded our platform's design system components, incorporating more elements to enhance your user experience. Here's what's new:

1.  **Text Input Field:**

    - We've added a sleek and user-friendly text input field to various sections of the platform, making data entry and interactions smoother and more intuitive.

2.  **Pagination Enhancement:**

    - Our pagination system has been upgraded for improved navigation through large datasets, ensuring a seamless browsing experience with faster access to content.

3.  **Tooltip Feature:**

    - Introducing tooltips across the platform to provide helpful hints and information, enhancing user understanding and interaction with different elements.

## Platform Improvements & Fixes

**Crypto Payment:** We have incorporated the CopperX payment gateway to enhance user experience and increase payment success rates.

**Bracket System:** We have implemented bracket system checks within our instance creation UI. Moreover, you can review the complete range of brackets and monitor your current CPU, RAM, and Storage usage directly from the UI, ensuring you have sufficient balance for deploying your new instance.

**Breadcrumbs:** We have resolved the issue where that caused 'null' to appear intermittently in the breadcrumbs on the instance page.

**Template Page:** We have fixed the issue where template name was showing for multi-service templates instead of template ID.

**Health Check:** We have now enabled the provision to add a separate health check URL for each service on multi-service instances.

**Instance Status:** We have rectified the issue where instance status was not getting updated on project instances page past deployment.

**Instance Logs:** We have fixed the issue where incorrect logs color was showing for some lines in the instance logs on certain nodes.

**Email Preferences:** We have added an option for bulk selection of all email types within a specific category.

**Instance Replica Price:** We have resolved the issue where price was not updating when changing replica count on multi-service templates.

**Total Spent:** We have rectified the displayed total spent amount for instance deployments on the compute billing page.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
